import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Spacer } from '../spacer/Spacer';
import { Tag } from '../tag';
import { Typography } from '../typography/Typography';
import HtmlContent from '../htmlContent/HtmlContent';

// Interface

export interface TitleBlockProps {
  centered?: boolean;
  tag?: string;
  subHeading?: string;
  heading?: string;
  description?: string;
}

// Styles

export const StyledTitleBlock = styled(Spacer)<TitleBlockProps>`
  ${({ centered }) => css`
    max-width: 736px;
    ${centered &&
    css`
      text-align: center;
      margin-right: auto;
      margin-left: auto;
    `};
  `};
`;

// JSX

export const TitleBlock: FC<TitleBlockProps> = ({
  centered,
  tag,
  subHeading,
  heading,
  description,
}) => (
  <StyledTitleBlock centered={centered}>
    <Spacer spacing="small">
      {tag && <Tag label={tag} />}
      {subHeading && (
        <Typography component="p" variant="caps">
          {subHeading}
        </Typography>
      )}
      {heading && <HtmlContent>{heading}</HtmlContent>}
      {description && (
        <Typography component="p" variant="bodyLarge">
          {description}
        </Typography>
      )}
    </Spacer>
  </StyledTitleBlock>
);

export default TitleBlock;
